export default __webpack_public_path__ + "static/media/Edge_Instrumentation.1d3af95e.png";